import { ChangeDetectionStrategy, Component, effect, Input, input, OnInit } from '@angular/core';
import { ChartCardComponent } from '../chart-card/chart-card.component';

import { TableModule } from 'primeng/table';
import { BaseDashboardChartComponent } from '../base-dashboard-chart.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'co-chart-table',
  imports: [ChartCardComponent, TableModule, TranslatePipe],
  templateUrl: './chart-table.component.html',
  styleUrl: './chart-table.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartTableComponent extends BaseDashboardChartComponent {
  @Input() tableData: any[] = [];
  @Input() tableColumns: string[] = [];
  @Input() chiSquaredResult: any;
  @Input() compareByLabel: string = '';

  constructor(private translate: TranslateService) {
    super();
  }

  getColumnLabel(col: string): string {
    if (col === 'Group') return this.compareByLabel;
    if (col === 'ChangeFromPrevious') {
      const month = this.selectedFilters['month'];
      return !month || month === 'All' || month === undefined
        ? 'Change from Previous Months'
        : `Change from Previous ${month}`;
    }
    return col;
  }

  exportCsv() {
    console.log('rows length =', this.tableData?.length);

    if (!this.tableData || this.tableData.length === 0) {
      return;
    }

    const headers = [...this.tableColumns];

    const csvRows: string[] = [];
    csvRows.push(headers.join(','));

    this.tableData.forEach((r) => {
      const row = this.tableColumns.map(col => r[col]);

      csvRows.push(
        row
          .map((v) => `"${(v ?? '').toString().replace(/"/g, '""')}"`)
          .join(',')
      );
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'Report.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  override onDropdownChange(): void {
    this.onFilterChange.emit(this.selectedFilters);
  }
}
